import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {StepIcon} from 'shells/icon/svg/step-icon';

import type {FormStubFragment} from 'nutshell-graphql-types';

import {getStagesetLabel} from './helpers';

export function FormTertiaryInfo(props: {form: FormStubFragment}) {
    const stagesetLabel = getStagesetLabel(props.form);

    return (
        <div className='flex flex-dir-col gap-4'>
            <span>
                {props.form.numSubmissions.toLocaleString()}{' '}
                {props.form.numSubmissions === 1 ? 'submission' : 'submissions'}
            </span>
            {stagesetLabel ? (
                <span className='flex gap-4 align-center'>
                    <StepIcon
                        wrapWithDiv={false}
                        style={{flexShrink: 0}}
                        fill={colors.greyLt}
                        size={14}
                    />
                    <span className='truncate'>{stagesetLabel}</span>
                </span>
            ) : null}
        </div>
    );
}
